import axios from "@/libs/api.request";

//查询
export const getRechargeList = (filterCond) => {
  return axios.request({
    url: "rechargeCard/getRechargeList",
    data: filterCond,
    csrf: false,
    method: "post",
  });
};

export const createRechareCard = (data) => {
  return axios.request({
    url: "rechargeCard/createRechareCard",
    data: data,
    csrf: true,
    method: "post",
  });
};

export const storeRechargeCard = (data) => {
  return axios.request({
    url: "rechargeCard/storeRechargeCard",
    data: data,
    csrf: true,
    method: "post",
  });
};

export const removeRechargeCard = (id) => {
  return axios.request({
    url: "rechargeCard/removeRechargeCard",
    data: { id },
    csrf: true,
    method: "post",
  });
};

export const downloadRechargeCard = (filterCond) => {
  return axios.request({
    url: "rechargeCard/downloadRechargeCard",
    data: filterCond,
    csrf: false,
    method: "post",
  });
};
